import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=df58b82c&scoped=true"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=df58b82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df58b82c",
  null
  
)

export default component.exports